import { ankrMethods } from './ankr/methods.js';
import { blockchairMethods } from './blockchair/methods.js';
import { blockcypherMethods } from './blockcypher/methods.js';
import { mempoolMethods } from './mempool/methods.js';
export function getRpcProviderMethods(key) {
    switch (key) {
        case 'blockchair':
            return blockchairMethods;
        case 'ankr':
            return ankrMethods;
        case 'blockcypher':
            return blockcypherMethods;
        case 'mempool':
            return mempoolMethods;
        default:
            return null;
    }
}
//# sourceMappingURL=getRpcProviderMethods.js.map